module.exports = __webpack_public_path__ + "media/images/kent_fenwick-21b1e185643f657099adcbec3abc9e6a.jpg";